module.exports = __webpack_public_path__ + "img/pr.60cc8cc3.svg";